import types from './types'

const currencyActions = {
  setList: (list: []) => ({ type: types.SET_LIST, payload: list }),
}

export default currencyActions
